<template>
  <div class="ReloadingStatistics mainWrap" v-loading.fullscreen.lock="fullscreenLoading">
    <el-container style="height:100%; background-color:rgba(0, 0, 0, 0);">
      <!-- 左边导航栏 -->
      <el-aside style="width:auto;">
        <leftNav msg="/ER001"></leftNav>
      </el-aside>
      <!-- 右侧主体部分 -->
      <el-container>
        <!-- 页面部分 -->
        <el-scrollbar class="machineWrap" style="height:100%;width:100%;">
          <el-main>
            <div class="mainWrao">
              <div class="recordTitle">
                <h1>{{$t('leftNav.navThirteen')}}</h1>
                <div style="float:right;display:flex;align-items:center;">
                  <label style="margin-right:10px;font-size:12px;">{{$t('StepCycleTime.labelTitle1')}}</label>
                  <!-- <el-cascader
                    class="idStyle"
                    :placeholder="$t('StepCycleTime.placehoder1')"
                    expand-trigger="hover"
                    :options="options"
                    filterable
                    @change="getTableData()"
                    v-model="machineID">
                  </el-cascader> -->
                  <equipment @change="getchange" class="machinevue" :machine="machineID[1]"></equipment>
                </div>
              </div>
              <div class="tableWrap">
                <div class="times">
                  <el-date-picker
                    class="picker"
                    v-model="selectTime"
                    type="date"
                    :picker-options="pickerOptions"
                    :clearable='false'
                    @change="timeChange"
                    placeholder="选择日期"
                    value-format="timestamp">
                  </el-date-picker>
                  <el-button icon="el-icon-arrow-left" @click="changeDate('l')" :disabled='tableLoading === true '></el-button>
                  <el-button icon="el-icon-arrow-right" @click="changeDate('r')" :disabled='selectTime ===nowTime || tableLoading === true'></el-button>
                  <span class="machineID">{{showMachineID}}</span>
                  <span class="range">{{timeArr[0]}} ~ {{timeArr[1]}}</span>
                  <el-button v-show="this.$store.state.authority.PageDownload.show" icon="el-icon-download" class="export" @click="exportExcel()">{{$t('ReloadingStatistics.export')}}</el-button>
                </div>
                <!-- 表格 -->
                <div class="mainTable">
                  <el-table
                    :data="tableData"
                    v-loading="tableLoading"
                    :empty-text="$t('WorkShopDashBoard.noEquipmentTableMessage')"
                    show-summary
                    :sum-text="$t('ReloadingStatistics.Total')"
                    style="width: 100%;margin:15px 0;">
                    <el-table-column type="expand">
                      <template slot-scope="props">
                        <el-table
                          :data="props.row.list"
                          :row-class-name="tableRowClassName"
                          style="width:890px;float:right;">
                          <el-table-column
                            type="index"
                            :label="$t('ReloadingStatistics.innerTitle1')"
                            width="80">
                          </el-table-column>
                          <el-table-column
                            prop="startTime"
                            :label="$t('ReloadingStatistics.innerTitle4')"
                            >
                          </el-table-column>
                          <el-table-column
                            prop="endTime"
                            :label="$t('ReloadingStatistics.innerTitle2')"
                            >
                          </el-table-column>
                          <el-table-column
                            prop="duration"
                            :label="$t('ReloadingStatistics.innerTitle5')"
                            width="100">
                          </el-table-column>
                          <el-table-column
                            prop="number"
                            :label="$t('ReloadingStatistics.innerTitle3')"
                            width="180">
                          </el-table-column>
                          <el-table-column
                            prop="output"
                            :label="$t('ReloadingStatistics.innerTitle6')"
                            width="80">
                          </el-table-column>
                          <el-table-column
                            prop="cutting"
                            :label="$t('ReloadingStatistics.innerTitle7')"
                            width="80">
                          </el-table-column>
                        </el-table>
                      </template>
                    </el-table-column>
                    <el-table-column
                      :label="$t('ReloadingStatistics.tableTitle1')"
                      width="130">
                      <template slot-scope="scope">
                        <span>{{scope.row.code}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      :label="$t('ReloadingStatistics.tableTitle2')"
                      prop="event"
                      width="200">
                    </el-table-column>
                    <el-table-column
                      :label="$t('ReloadingStatistics.tableTitle3')"
                      prop="unit"
                      >
                    </el-table-column>
                  </el-table>
                </div>
                <div class="times" style="margin-top:20px;">
                  <el-date-picker
                    class="picker"
                    v-model="selectTime"
                    type="date"
                    :clearable='false'
                    :picker-options="pickerOptions"
                    @change="timeChange"
                    placeholder="选择日期"
                    value-format="timestamp">
                  </el-date-picker>
                  <el-button icon="el-icon-arrow-left" @click="changeDate('l')" :disabled='tableLoading === true '></el-button>
                  <el-button icon="el-icon-arrow-right" @click="changeDate('r')" :disabled='selectTime ===nowTime || tableLoading === true'></el-button>
                  <span class="machineID">{{showMachineID}}</span>
                  <span class="range">{{timeArr[0]}} ~ {{timeArr[1]}}</span>
                </div>
              </div>       
            </div>
          </el-main>
        </el-scrollbar>
      </el-container>
    </el-container>
    
  </div>
</template>

<script>

import { formatDate } from '../assets/js/date.js'
import leftNav from "@/components/nav.vue"
import equipment from "@/components/Equipment.vue"
import { Promise } from 'q';
// import { Loading } from 'element-ui'

export default {
  name: 'ReloadingStatistics',
  components: {
    leftNav,
    equipment
  },
  data () {
    return {
      //  模拟数据
      options: [],
      // 选中的机械id
      machineID: [Number(this.$store.state.defaultFactoryId),Number(this.$store.state.defaultId)],
      fullscreenLoading: false,
      tableLoading: false,
      // 表格数据
      tableData:[],
      // 时间
      selectTime: null,
      nowTime: null,
      // 当前机械的班组开始时间
      workTime: '',
      // 按钮边显示的时间范围
      timeArr: [],
      // 时间选择器禁用
      pickerOptions:{
        disabledDate: (time) =>{
          return time.getTime() > this.nowTime
        }
      },
      showMachineID: '',
      // noMachine:false
    }
  },
  beforeMount(){
    this.$store.commit('toLogin')
  },
  mounted() {
    this.$store.commit('authority' , this.$route.path)
    this.getManiceList()
    this.getdate()
  },
  computed: {
    islangChange () {
      return this.$store.state.lang
    }
  },
  watch: {
    islangChange (curval, oldval) {
      if (curval != oldval) {
        this.$parent.reload()
      }
    }
  },
  // filters: {
  //   formatDate (time) {
  //     if (time === null || time === '') {
  //       return ''
  //     }
  //     var date = new Date(time)
  //     return formatDate(date, 'MM-dd hh:mm')
  //   }
  // },
  methods: {
    // 切换设备
    getchange(value){
      this.machineID[1]=value
      this.getTableData()
    },
    // 获取车间列表
    getManiceList() {
      let _this = this
      this.axios({
        method: 'get',
        url: '/url/selectChooseManice',
        params:{
          language: _this.$store.state.lang
        }
      }).then(function(res){
        if (res.data.success === 'true') {
            // _this.noMachine=false
          if(res.data.options !==undefined && res.data.options.length > 0 ){
            if(localStorage.getItem('isMarketAccount') === '1') {
              _this.$store.commit('marketAccount',res.data.options)
            }
            _this.options = res.data.options
          }else{
            _this.options = res.data.options
            // _this.noMachine=true
          }
        } else {
          _this.$message.error('Machine list loading failed')
        }
      })
    },
    // 获取当前日期和早班开始时间
    getdate(){
      this.fullscreenLoading = true
      let _this = this
      this.axios({
        method: 'post',
        url: '/url/getReloadingTime',
        params:{
          machineId: _this.machineID[1],
          language: _this.$store.state.lang
        }
      }).then(function(res){
        if (res.data.success === 'true') {
          _this.selectTime = res.data.date
          _this.nowTime = res.data.date
          _this.workTime = res.data.time
          _this.timeRange()
        } else {
          _this.$message.error(res.data.msg)
        }
      }).then(function(){
        _this.getTableData()
      })
    },
    // 按钮控制时间
    changeDate(a){
      this.tableLoading = true
      if(a === 'l'){
        this.selectTime-=86400000
      }else{
        this.selectTime+=86400000
      }
      let _this = this
      new Promise(function(resolve) {
        _this.timeRange()
        resolve();
      }).then(function() {
        _this.getTableData()
      })
    },
    // 按钮边显示的时间范围
    timeRange(){
      let startTime = `${formatDate(new Date(this.selectTime), 'yyyy/MM/dd')}${this.workTime}`
      let endTime = `${formatDate(new Date(this.selectTime+86400000), 'yyyy/MM/dd')}${this.workTime}`
      this.timeArr = [startTime, endTime]
  
    },
    timeChange(){
      let _this = this
      new Promise(function(resolve) {
        _this.timeRange()
        resolve();
      }).then(function() {
        _this.getTableData()
      })
    },
    // 获取表格数据
    getTableData(){
      this.tableLoading = true
      let _this = this
      this.axios({
        method: 'post',
        url: '/url/getReloadingStatistic',
        params:{
          machineId: _this.machineID[1],
          startTime: _this.timeArr[0],
          endTime: _this.timeArr[1],
          language: _this.$store.state.lang
        }
      }).then(function(res){
        if('machine' in res.data){
          if (res.data.success === 'true') {
            _this.tableData = res.data.data
            _this.showMachineID = res.data.machine.equipmentName+'('+res.data.machine.nameEn+')'
          } else {
            _this.$message.error(res.data.msg)
          }
        }else{
          
        }
        _this.fullscreenLoading = false
        _this.tableLoading = false
      })
    },
    tableRowClassName({row}) {
      if (row.color === true) {
        return 'warning-row';
      }
      return '';
    },
    //导出
    exportExcel(){
      if(this.tableData == null || this.tableData.length == 0){
        this.$message.error(this.$t('gantt.error'));
      }else{
        let signTime = new Date().getTime()
        this.$store.commit('nowsign', signTime)
        if(this.machineID[1] && this.timeArr[0] && this.timeArr[1]){
          let urlData = '?machineId=' + this.machineID[1] + '&startTime=' + this.timeArr[0] + '&endTime=' + this.timeArr[1] + '&language='+ this.$store.state.lang + '&sign='+this.$store.state.sign + '&auth_Code='+this.$store.state.authCode+'&sign_time='+signTime +'&route='+this.$store.state.newroute+'&factory_id='+this.$store.state.factoryId
          window.open('/url/excelExportReloadingStatistic' + urlData, '_blank')
        }
      }       
    }
  }
  
}
</script>
<style scoped>
.ReloadingStatistics{
  min-width: 1365px!important;
}
.mainWrao{
  height: 100%;
  min-width: 100%;
  background-color: #f6f9fc;
  box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  border-radius: 4px;
  padding-bottom: 30px;
}
.recordTitle{
  padding: 20px 25px;
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
  border-radius: 4px 4px 0 0;
  line-height: 35px;
}
.recordTitle h1{
  font-size: 20px;
  color: #525f7f;
  margin-bottom: 5px;
  display: inline-block;
}
.tableWrap{
  box-sizing: border-box;
  margin: 20px 15px;
}
.times .picker{
  margin-right:15px;
}
.times button{
  padding: 12px;
}
.times .range{
  font-size: 14px;
  margin-left: 25px
}
.times .export{
  float:right;
  width: 100px;
}
.times .machineID{
  font-weight: bold;
  font-size: 14px;
  margin-left: 25px
}
.mainTable{
  background-color:#fff;
  padding-bottom:5px;
  border-radius: 0 0 3px 3px;
  box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.15);
}

</style>

